/* TRAX TOKYO theme JS */
(function () {
  'use strict';

  /* ---------- menu drawer ---------- */
  var drawer = document.getElementById('MenuDrawer');
  var openBtn = document.querySelector('[data-drawer-open]');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');
    var close = drawer.querySelector('[data-drawer-close]');
    if (close) close.focus();
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  if (openBtn) openBtn.addEventListener('click', openDrawer);
  if (drawer) {
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
  }

  /* ---------- search overlay ---------- */
  var search = document.getElementById('SearchOverlay');
  var searchBtn = document.querySelector('[data-search-open]');
  if (searchBtn && search) {
    searchBtn.addEventListener('click', function () {
      var open = search.classList.toggle('is-open');
      search.setAttribute('aria-hidden', open ? 'false' : 'true');
      searchBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var input = search.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDrawer();
    if (search && search.classList.contains('is-open')) {
      search.classList.remove('is-open');
      search.setAttribute('aria-hidden', 'true');
      if (searchBtn) { searchBtn.setAttribute('aria-expanded', 'false'); searchBtn.focus(); }
    }
  });

  /* ---------- announcement bar live clock (Ginza,TOKYO | date | time) ---------- */
  document.querySelectorAll('[data-live-clock]').forEach(function (el) {
    var place = el.getAttribute('data-place') || 'Ginza,TOKYO';
    var tz = el.getAttribute('data-tz') || 'Asia/Tokyo';
    function tick() {
      try {
        var now = new Date();
        var date = new Intl.DateTimeFormat('en-US', {
          weekday: 'long', month: 'long', day: '2-digit', year: 'numeric', timeZone: tz
        }).format(now);
        var time = new Intl.DateTimeFormat('en-GB', {
          hour: '2-digit', minute: '2-digit', hour12: false, timeZone: tz
        }).format(now);
        el.textContent = place + ' | ' + date + ' | ' + time + ' JST';
      } catch (err) { /* keep server-rendered fallback */ }
    }
    tick();
    setInterval(tick, 30000);
  });

  /* ---------- quantity steppers ---------- */
  document.querySelectorAll('.quantity-input').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        v += btn.dataset.step === 'up' ? 1 : -1;
        input.value = Math.max(1, v);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---------- AJAX add to cart (falls back to normal submit) ---------- */
  var productForm = document.querySelector('form[data-ajax-cart]');
  if (productForm && window.fetch) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = productForm.querySelector('[type="submit"]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = btn.dataset.addingText || '...'; }
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        body: new FormData(productForm)
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('.cart-count-bubble').forEach(function (b) {
            b.textContent = cart.item_count;
            b.setAttribute('data-count', cart.item_count);
          });
          if (btn) { btn.textContent = btn.dataset.addedText || original; }
          setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = original; } }, 1600);
        })
        .catch(function () { productForm.submit(); });
    });
  }

  /* ---------- collection sort auto-submit ---------- */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var form = sortSelect.closest('form');
      if (form) form.submit();
    });
  }

  /* ---------- product gallery thumbs ---------- */
  var mainImg = document.querySelector('[data-gallery-main] img');
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = t.dataset.src;
      mainImg.srcset = '';
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
      t.setAttribute('aria-current', 'true');
    });
  });
})();
